// booking/components/FormRadioGroup.jsx
import React, { memo } from 'react';
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  FormHelperText,
} from '@mui/material';

const FormRadioGroup = memo(
  ({
    name,
    formik,
    background,
    options = [
      { value: 'sr', label: 'Sr.' },
      { value: 'sra', label: 'Sra.' },
    ],
    error,
    helperText,
    ...props
  }) => (
    <FormControl error={error}>
      <RadioGroup
        name={name}
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        row
        value={formik.values[name]}
        {...props}
      >
        {options.map((option) => (
          <FormControlLabel
            control={
              <Radio
                sx={{
                  '&.Mui-checked': {
                    color: background,
                  },
                }}
              />
            }
            key={option.value}
            label={<Typography fontSize='0.875rem'>{option.label}</Typography>}
            value={option.value}
          />
        ))}
      </RadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  )
);

FormRadioGroup.displayName = 'FormRadioGroup';

export default FormRadioGroup;
